





















































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
const storeSpace = namespace("warrantyCheck");
import {
  pagination,
  loadingCatch,
  loading,
  SearchbarControl
} from "@root/lib/decorator";
const root = namespace("root");

@Component({})
@SearchbarControl()
@pagination("getDataList", { pageSize: 50 })
@loading(true)
export default class warrantyCheck extends Vue {
  formOptionList: any = [
    {
      label: "创建时间",
      key: "time",
      type: "datePicker",
      value: "",
      pickerType: "datetimerange",
      rangeSeparator: "-",
      prefixIcon: "",
      valueFormat: "yyyy-MM-dd HH:mm:ss",
      defaultTime: ["00:00:00", "23:59:59"]
    },
    {
      key: "storeCode",
      value: "",
      label: "门店",
      type: "input"
    },
    {
      key: "ownerMobile",
      value: "",
      label: "车主手机号",
      type: "input"
    },
    {
      key: "warrantyCard",
      value: "",
      label: "质保卡号",
      type: "input"
    },
    {
      key: "tyreCode",
      value: "",
      label: "胎号",
      type: "input"
    },

    {
      key: "warrantyStatus",
      value: null,
      label: "状态",
      type: "ddPicker",
      ddCode: "WARRANTY_STATUS",
      stateName: "WARRANTY_STATUS"
    }
  ];
  onFormDataChange(val: any) {
    this.form = { ...val };
  }
  form: any = {
    time: [null, null],
    warrantyStatus: null
  };
  loading: boolean = false;
  total: number = 0;
  @storeSpace.Action("queryWarrantyDetailList") queryData;
  @storeSpace.Action("exportWarrantyDetail") export;
  @storeSpace.State("detailList") dataList;
  @root.State ddCodes;
  created() {
    this.$dd.register(["WARRANTY_STATUS"]).query();
  }
  mounted() {
    this.getDataList();
  }
  async getDataList() {
    const { pageSize, currentPage: pageNum }: any = this;
    this.loading = true;
    const { time, ...other } = this.form;

    await this.queryData({
      pageInput: {
        pageSize,
        pageNum
      },
      input: {
        startTime: (time && time[0]) || null,
        endTime: (time && time[1]) || null,
        ...other
      }
    })
      .then(({ total = 0 }) => {
        this.total = total;
      })
      .finally(() => {
        this.loading = false;
      });
  }
  async handleExport() {
    (this.$refs.gtExportDialog as any).visible = true;
  }
  async exportExcelFn() {
    const { time, ...other } = this.form;
    await this.export({
      input: {
        startTime: (time && time[0]) || null,
        endTime: (time && time[1]) || null,
        ...other
      }
    });
  }

  getRowLabel(row, prop) {
    if (!row) return "";
    const val = (prop && row && row[prop]) || "";
    const obj = this.ddCodes.WARRANTY_STATUS_MAP;
    return obj && obj[val];
  }
}
